<template>
  <v-container class="cmp-royalty-contracts-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <ContractDetailsSetup
        :selectedContractDetails="selectedContractDetails"
        :loading="selectedContractDetails && selectedContractDetails.loading"
        @changed="onContractChanged"
      />
      <glayout
        :tabs="contractSidewindowTabs"
        :options="[
          {
            text: $t('documents_string'),
            value: 'documents',
          },
          {
            text: 'Delete',
            value: 'delete',
            error: true,
          },
        ]"
        :loading="selectedContractDetails && selectedContractDetails.loading"
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <!-- <grow>
            <gcol>
              <gbox
                :title="$t('contract_setup')"
                :h="mechanicalFlag ? 190 : 256"
              >
                <ContractSetup
                  :selectedContractDetails="selectedContractDetails"
                  @changed="onContractChanged"
                />
              </gbox>
            </gcol>
            <gcol> </gcol>
          </grow> -->
          <grow>
            <gcol>
              <gbox
                :title="`${$t('releases')} (${
                  selectedContractDetails.releases &&
                  selectedContractDetails.releases.length
                })`"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedContractDetails &&
                      selectedContractDetails.releases &&
                      selectedContractDetails.releases.length,
                    offset: releasesSearchFlag
                      ? NTOffsets.WithHeaderDBoxBottom + 64
                      : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
              >
                <Releases
                  :channel="'releases'"
                  @emitSearchString="onApplyFilter"
                  :selectedContractDetails="selectedContractDetails"
                  @showSearchFlag="onReleasesSearchClick"
                  @changed="onContractReleasesChanged"
                  @selected="onSelectedRelease"
                  @deleted="onContractDeleted"
                  @deletedAll="onContractDeletedAll"
                  @add_click="onReleasesAddClick"
                  @added="onAutoFillFromReleases"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="`${$t('products')} (${
                  selectedContractDetails.products &&
                  selectedContractDetails.products.length
                })`"
                :h="
                  boxHeightNamed({
                    rowCount: dBoxProductsRowCount,
                    offset: productsSearchFlag
                      ? NTOffsets.WithHeaderDBoxBottom + 64
                      : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
              >
                <ContractProducts
                  :channel="'products'"
                  :selectedContractDetails="selectedContractDetails"
                  @showSearchFlag="onProductsSearchClick"
                  @emitSearchString="onApplyFilter"
                  @selected="onSelectedProducts"
                  @changed="onContractProductsChanged"
                  @deleted="onContractDeleted"
                   @edit="openEditProduct"
                  @deletedAll="onContractDeletedAll"
                  @add_click="onProductsAddClick"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="`${$t('tracks')} (${
                  selectedContractDetails.tracks &&
                  selectedContractDetails.tracks.length
                })`"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedContractDetails &&
                      selectedContractDetails.tracks &&
                      selectedContractDetails.tracks.length,
                    offset: tracksSearchFlag
                      ? NTOffsets.WithHeaderDBoxBottom + 64
                      : NTOffsets.WithHeaderDBoxBottom,
                  })
                "
              >
                <ContractTracks
                  :channel="'tracks'"
                  @emitSearchString="onApplyFilter"
                  @showSearchFlag="onTracksSearchClick"
                  :selectedContractDetails="selectedContractDetails"
                  @changed="onContractTracksChanged"
                  @deletedAll="onContractDeletedAll"
                  @deleted="onContractDeleted"
                  @add_click="onTracksAddClick"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="royalty_rates">
          <grow>
            <gcol>
              <gbox
                v-if="!mechanicalFlag"
                :title="$t('physical')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.physical_royalty_options &&
                      selectedContractDetails.physical_royalty_options.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <RoyaltyRate
                  :channel="'physical'"
                  :basesTV="selectedContractDetails.physicalBasesTV"
                  :list="selectedContractDetails.physical_royalty_options"
                  @changed="(e) => onRoyaltyRateChanged('physical', e)"
                  @added="(e) => onRoyaltyRateAddClick('physical', e)"
                  @edited="(e) => onRoyaltyRateEditClick('physical', e)"
                  @deleted="(e) => onDeletedRoyaltyRate('physical', e)"
                />
              </gbox>
              <gbox
                v-if="!mechanicalFlag"
                :title="$t('digital')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.digital_royalty_options &&
                      selectedContractDetails.digital_royalty_options.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <RoyaltyRate
                  :channel="'digital'"
                  :basesTV="selectedContractDetails.digitalBasesTV"
                  :list="selectedContractDetails.digital_royalty_options"
                  @changed="(e) => onRoyaltyRateChanged('digital', e)"
                  @added="(e) => onRoyaltyRateAddClick('digital', e)"
                  @edited="(e) => onRoyaltyRateEditClick('digital', e)"
                  @deleted="(e) => onDeletedRoyaltyRate('digital', e)"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                v-if="!mechanicalFlag"
                :title="$t('reserve_setup')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.reserve_settings &&
                      selectedContractDetails.reserve_settings.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <ReserveSetup
                  :selectedContractDetails="selectedContractDetails"
                  @added="onAddedReserveSetup"
                  @changed="onReserveSetupChanged"
                  @deleted="onDeletedReserveSetup"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                v-if="!mechanicalFlag"
                :title="$t('scales')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.scales &&
                      selectedContractDetails.scales.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <RoyaltyScale
                  :selectedContractDetails="selectedContractDetails"
                  @added="onScaleTypesClick"
                  @edited_qty="onRoyaltyScaleQtyEditClick"
                  @edited_turnover="onRoyaltyScaleTurnoverEditClick"
                  @changed="onRoyaltyScaleChanged"
                  @deleted="onDeletedRoyaltyScale"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol f=".5">
              <gbox
                v-if="mechanicalFlag || displayAutoBalanceSubtab"
                :title="$t('harry_fox')"
                h="194"
              >
                <HarryFox
                  :selectedContractDetails="selectedContractDetails"
                  @changed="onHarryFoxChanged"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab v-if="!mechanicalFlag" id="licencing" :title="$t('licencing_nr')">
          <grow>
            <gcol>
              <gbox
                :title="$t('performance')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.performance_royalty_options &&
                      selectedContractDetails.performance_royalty_options
                        .length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <!-- :channel="$t('add_new_performance')" -->
                <LicencingNr
                  :channel="`${$t('add_new')} ${$t('performance')}`"
                  :list="selectedContractDetails.performance_royalty_options"
                  @changed="(e) => onLicensingChanged('performance', e)"
                  @added="(e) => onLicencingNrAddClick('performance', e)"
                  @edited="(e) => onLicencingNrEditClick('performance', e)"
                  @deleted="(e) => onDeletedLicensing('performance', e)"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$t('thirdparty_party_string')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.thirdparty_royalty_options &&
                      selectedContractDetails.thirdparty_royalty_options.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <!-- :channel="$t('add_new_thirdparty')" -->
                <LicencingNr
                  :channel="`${$t('add_new')} ${$t('thirdparty')}`"
                  :list="selectedContractDetails.thirdparty_royalty_options"
                  @changed="(e) => onLicensingChanged('thirdparty', e)"
                  @added="(e) => onLicencingNrAddClick('thirdparty', e)"
                  @edited="(e) => onLicencingNrEditClick('thirdparty', e)"
                  @deleted="(e) => onDeletedLicensing('thirdparty', e)"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$t('licensing')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.licensing_royalty_options &&
                      selectedContractDetails.licensing_royalty_options.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <Licensing
                  :channel="'licensing'"
                  :list="selectedContractDetails.licensing_royalty_options"
                  :selectedContractDetails="selectedContractDetails"
                  @changed="(e) => onLicensingChanged('licensing', e)"
                  @added="onAddedLicencingNr"
                  @deleted="(e) => onDeletedLicensing('licensing', e)"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab
          id="contract_deductions"
          :title="$t('tab_title_contract_deductions')"
        >
          <grow>
            <gcol>
              <gbox
                :title="$t('contract_deduction_1')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.deductions4 &&
                      selectedContractDetails.deductions4.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <ContractDeductionsTable
                  @deleted="deleteContractDeduction"
                  @edit="editDeductions"
                  @add="addDeductions"
                  :deductions_target="'deduction4'"
                  :deductions="selectedContractDetails.deductions4"
                  :selectedContractDetails="selectedContractDetails"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$t('contract_deduction_2')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.deductions5 &&
                      selectedContractDetails.deductions5.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <ContractDeductionsTable
                  @deleted="deleteContractDeduction"
                  @edit="editDeductions"
                  @add="addDeductions"
                  :deductions_target="'deduction5'"
                  :deductions="selectedContractDetails.deductions5"
                  :selectedContractDetails="selectedContractDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="recoupables">
          <grow>
            <gcol>
              <gbox :title="$dft.capHead($t('recoupable_type'))" :h="100">
                <RecoupSetup
                  :selectedContractDetails="selectedContractDetails"
                  @changed="onContractChanged"
                />
              </gbox>
            </gcol>
            <gcol> </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                v-if="!mechanicalFlag"
                :title="$t('cost_group_setup')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.royalty_cost_groups &&
                      selectedContractDetails.royalty_cost_groups.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <RecoupablesGroup
                  :channel="'cost'"
                  :list="selectedContractDetails.royalty_cost_groups"
                  :groupsTV="selectedContractDetails.costGroupsTV"
                  :selectedContractDetails="selectedContractDetails"
                  @changed="(e) => onRecoupablesChanged('cost', e)"
                  @added="onAddedRecoupablesList"
                  @deleted="onDeletedRecoupables"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                v-if="!mechanicalFlag"
                :title="$t('income_group_setup')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.royalty_income_groups &&
                      selectedContractDetails.royalty_income_groups.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <RecoupablesGroup
                  :channel="'income'"
                  :list="selectedContractDetails.royalty_income_groups"
                  :groupsTV="selectedContractDetails.incomeGroupsTV"
                  :selectedContractDetails="selectedContractDetails"
                  @changed="(e) => onRecoupablesChanged('income', e)"
                  @added="onAddedRecoupablesList"
                  @deleted="onDeletedRecoupables"
                />
              </gbox>
            </gcol>
          </grow>
          <!-- <grow>
            <gcol f="0.5">
              <gbox
                v-if="mechanicalFlag || displayAutoBalanceSubtab"
                :title="$t('recoupables_reserve_setup')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.reserve_settings &&
                      selectedContractDetails.reserve_settings.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <ContractReserveSettings
                  :mechanicalFlag="mechanicalFlag"
                  :selectedContractDetails="selectedContractDetails"
                  @added="onAddedContractReserveSettings"
                  @changed="onContractReserveSettingsChanged"
                  @deleted="onDeletedContractReserveSettings"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                v-if="mechanicalFlag || displayAutoBalanceSubtab"
                :title="$t('contract_recoupables')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.balances_12 &&
                      selectedContractDetails.balances_12.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <ContractBalances
                  :mechanicalFlag="mechanicalFlag"
                  :channel="'recoupables'"
                  :balanceTV="selectedContractDetails.RecoupableBalanceTypeTV"
                  :list="selectedContractDetails.balances_12"
                  @added="onAddedContractBalances"
                  @changed="(e) => onContractBalancesChanged('recoupables', e)"
                  @deleted="onDeletedContractBalances"
                  @fetch="onfetchRecoupableBalance"
                />
              </gbox>
              <gbox
                v-if="mechanicalFlag || displayAutoBalanceSubtab"
                :title="$t('carried_over')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.balances_34 &&
                      selectedContractDetails.balances_34.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <ContractBalances
                  :mechanicalFlag="mechanicalFlag"
                  :channel="'carried_over'"
                  :balanceTV="selectedContractDetails.balanceTypeTV"
                  :list="selectedContractDetails.balances_34"
                  @added="onAddedContractBalances"
                  @changed="(e) => onContractBalancesChanged('carried_over', e)"
                  @deleted="onDeletedContractBalances"
                  @fetch="onfetchRecoupableBalance"
                />
              </gbox>
            </gcol>
          </grow> -->
        </gtab>
        <gtab v-if="!mechanicalFlag" id="balances">
          <grow>
            <gcol>
              <!-- :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.balances &&
                      selectedContractDetails.balances.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                " -->
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedContractDetails &&
                      selectedContractDetails.balances &&
                      groupedRowCount(selectedContractDetails.balances),
                    min: 0,
                  })
                "
                :title="$t('balances')"
              >
                <Balances
                  :selectedContractDetails="selectedContractDetails"
                  @added="onContractBalance"
                  @fetch="onfetchBalance"
                  @changed="onBalanceChanged"
                  @deleted="onDeletedBalance"
                  @searched="onContractBalance"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="history">
          <grow>
            <gcol>
              <gbox
                :title="$t('tab_title_statements')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedContractDetails &&
                      selectedContractDetails.statements &&
                      selectedContractDetails.statements.length,
                    offset: NTOffsets.WithHeader,
                    rowHeight: 44,
                    min: 1,
                  })
                "
              >
                <HistoryStatements
                  :selectedContractDetails="selectedContractDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="specials">
          <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    @click="onAutoFetchLabelSupplierClick"
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                  >
                    {{ $t("auto_fetch_label_supplier") }}
                  </button>
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :title="$t('auto_fetch')"
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.relations &&
                      selectedContractDetails.relations.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
              >
                <AutoFetch
                  :selectedContractDetails="selectedContractDetails"
                  @add_click="onAutoFetchAddClick"
                  @deleted="onDeletedAutoFetch"
                />
              </gbox>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedContractDetails.contract.notes"
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedContractDetails &&
                      selectedContractDetails.files &&
                      selectedContractDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedContractDetails.files"
                  :externalId="`${this.selectedContractDetails.contract.contract_id}`"
                  :externalTable="'contracts'"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'autoFillFromTrack'" :width="'500'">
      <AutoFillFromTrack
        @cancelled="onDialogCancelled"
        @added="onAutoFillTrackList"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'autoFillFromRelease'" :width="'500'">
      <AutoFillFromRelease
        @cancelled="onDialogCancelled"
        @added="onAutoFillFromReleases"
      />
    </ModalContainer>
    
    <ModalContainer :modalKey="'addReleases'" :width="'1000'">
      <AddReleases @cancelled="onDialogCancelled" @added="onReleasesAdded" />
    </ModalContainer>

    <ModalContainer :modalKey="'addTracks'" :width="'medium'">
      <AddTracks @cancelled="onDialogCancelled" @added="onTracksAdded" />
    </ModalContainer>

    <ModalContainer :modalKey="'addProducts'" :width="'medium'">
      <AddProducts @cancelled="onDialogCancelled" @added="onProductsAdded" />
    </ModalContainer>

    <ModalContainer :modalKey="'royaltyRateForm'" :width="'762'">
      <RoyaltyRateForm
        :selectedContractDetails="selectedContractDetails"
        @cancelled="onDialogCancelled"
        @added="(e) => onAddedRoyaltyRate(e)"
        @edited="(e) => onEditedRoyaltyRate(e)"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'licencingNrForm'" :width="'small'">
      <LicencingNrForm
        :selectedContractDetails="selectedContractDetails"
        @cancelled="onDialogCancelled"
        @edited="(e) => onEditedLicencingNr(e)"
        @added="(e) => onAddedLicencingNr(e)"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'scaleTypesForm'" :width="'550'">
      <ScaleTypesForm
        :selectedContractDetails="selectedContractDetails"
        @selected_qty="onAddedScaleQtyClick"
        @selected_turnover="onAddedScaleTurnoverClick"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'scaleQuantityForm'" :width="'medium'">
      <ScaleQuantityForm
        :selectedContractDetails="selectedContractDetails"
        @cancelled="onDialogCancelled"
        @added="onAddedQuantityScale"
        @edited="onEditedQuantityScale"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'scaleTurnoverForm'" :width="'medium'">
      <ScaleTurnoverForm
        :selectedContractDetails="selectedContractDetails"
        @cancelled="onDialogCancelled"
        @added="onAddedTurnoverScale"
        @edited="onEditedTurnoverScale"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'autoFetchForm'" :width="'small'">
      <AutoFetchForm
        :selectedContractDetails="selectedContractDetails"
        @cancelled="onDialogCancelled"
        @added="onAddedAutoFetch"
      />
    </ModalContainer>

    <!-- <ModalContainer :modalKey="'contractDocument'" :width="'500'">
      <ContractDocument :selectedContractDetails="selectedContractDetails" @cancelled="onDialogCancelled" />
    </ModalContainer> -->
    <ModalContainer :modalKey="'addDeductionsModal'" :width="'small'">
      <AddDeductionsModal
        @added="addedContractDedution"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editDeductionsModal'" :width="'small'">
      <EditDeductionsModal
        @added="addedContractDedution"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editMechanicalProduct'" :width="'medium'">
      <EditMechanicalProduct
        @cancelled="onDialogCancelled"
       @added="onAutoFillFromReleases"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import * as indexTypes from "../../../../store/app/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";

import { contractsRoyaltyGetters } from "../../store/contracts/getters";
import { contractsRoyaltyActions } from "../../store/contracts/actions";
import {
  royaltyAccountsListLDTRoutes,
  royaltyContractsListLDTRoutes,
} from "../../router/routes";
import {
  productsListLDTRoutes,
  releasesListLDTRoutes,
} from "../../../catalog/router/routes";

import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { checkTabListPermission } from "../../../../router/guard";
import { createTV } from "../../../../models/text-value.model";
import {
  createModalMixin,
  openModalRoute,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import { handleCloseTab } from "../../../../dt-plugins/sidewindow/nav-tab";
import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxTextarea from "@dtplugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import ModalContainer from "@dtplugins/modal/modal-container";

import ContractDetailsSetup from "./contract-details-setup.vue";
import ContractSetup from "./contract-setup";
import Releases from "./releases";
import AddReleases from "./add-Releases";
import ContractTracks from "./contract-tracks";
import AddTracks from "./add-tracks";
import AutoFillFromTrack from "./auto-fill-from-track";
import AutoFillFromRelease from "./auto-fill-from-release.vue";
import ContractProducts from "./contract-products";
import AddProducts from "./add-products";
import RelatedProducts from "./related-products";
import RoyaltyRate from "./royalty-rate";
import HarryFox from "./harry-fox";
import ReserveSetup from "./reserve-setup";
import RoyaltyScale from "./royalty-scale";
import ScaleTypesForm from "./scale-types-form";
import ScaleQuantityForm from "./scale-quantity-form";
import ScaleTurnoverForm from "./scale-turnover-form";
import RoyaltyRateForm from "./royalty-rate-form";
import HistoryStatements from "./history-statements";
import LicencingNr from "./licencing-nr";
import LicencingNrForm from "./licencing-nr-form";
import Licensing from "./licencing";
import RecoupablesGroup from "./recoupables-group";
import RecoupSetup from "./recoup-setup.vue";
import ContractReserveSettings from "./contract-reserve-settings";
import ContractBalances from "./contract-balances";
import ContractDeductionsTable from "./contract-deductions-table.vue";
import AddDeductionsModal from "./add -deductions-modal.vue";
import EditDeductionsModal from "./edit-deductions-modal.vue";
import EditMechanicalProduct from "./edit-mechanical-product.vue";
import Balances from "./balances";
import AutoFetch from "./auto-fetch";
import AutoFetchForm from "./auto-fetch-form";
// import ContractDocument from "./contract-document";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { ContractsService } from "../../services/contracts.service";
import { groupBy } from "lodash";

export const moduleRoute = "royalty";
export const submenuRoute = "contracts";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    ModalContainer,
    DBoxFiles,
    ContractSetup,
    Releases,
    AddReleases,
    ContractTracks,
    AddTracks,
    AutoFillFromTrack,
    ContractProducts,
    AddProducts,
    RelatedProducts,
    RoyaltyRate,
    RoyaltyRateForm,
    ReserveSetup,
    RoyaltyScale,
    ScaleTypesForm,
    ScaleQuantityForm,
    ScaleTurnoverForm,
    HarryFox,
    HistoryStatements,
    LicencingNr,
    LicencingNrForm,
    Licensing,
    RecoupablesGroup,
    Balances,
    AutoFetch,
    AutoFetchForm,
    // ContractDocument,
    RecoupSetup,
    ContractDetailsSetup,
    ContractReserveSettings,
    ContractBalances,
    ContractDeductionsTable,
    AddDeductionsModal,
    EditDeductionsModal,
    AutoFillFromRelease,
    EditMechanicalProduct 
  },
  data: function () {
    return {
      deductions_target: null,
      balancesSearchFlag: false,
      productsSearchFlag: false,
      tracksSearchFlag: false,
      releasesSearchFlag: false,
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addReleases"),
    createModalMixin("addTracks"),
    createModalMixin("autoFillFromRelease"),
    createModalMixin("autoFillFromTrack"),
    createModalMixin("addProducts"),
    createModalMixin("royaltyRateForm"),
    createModalMixin("licencingNrForm"),
    createModalMixin("scaleTypesForm"),
    createModalMixin("scaleQuantityForm"),
    createModalMixin("scaleTurnoverForm"),
    createModalMixin("autoFetchForm"),
    createModalMixin("contractDocument"),
    createModalMixin("addDeductionsModal"),
    createModalMixin("editDeductionsModal"),
    createModalMixin("editMechanicalProduct"),
  ],
  mounted: function () {
    console.log("MOUNTED", this.selectedContractDetails);
  },
  computed: {
    ...mapGetterObject(storeNS, contractsRoyaltyGetters),

    mechanicalFlag() {
      console.log(
        "mechanicalFlag ",
        this.selectedContractDetails?.contract?.mechanical_flag
      );
      return this.selectedContractDetails?.contract?.mechanical_flag;
    },
    displayContractDeductionsSubtab() {
      return this.display_contract_deductions_subtab || false;
    },

    displayAutoBalanceSubtab() {
      return this.display_auto_balance_subtab || false;
    },
    multiCurrencyRoyaltyFlag() {
      console.log(
        "multiCurrencyRoyaltyFlag",
        this.selectedContractDetails?.multi_currency_royalty_flag
      );
      return this.selectedContractDetails?.multi_currency_royalty_flag;
    },

    contractSidewindowTabs: function () {
      return checkTabListPermission(
        moduleRoute,
        submenuRoute,
        this.mechanicalFlag 
          ? [
              {
                route: "overview",
                value: this.$t("contract_items"),
              },
              {
                route: "royalty_rates",
                value: this.$t("tab_title_royalty_rates"),
              },
              {
                route: "recoupables",
                value: this.$t("recoupables"),
              },
              {
                route: "history",
                value: this.$t("statement_history"),
              },
              {
                route: "specials",
                value: this.$t("specials"),
              },
            ]:
         this.displayContractDeductionsSubtab &&
          !this.mechanicalFlag &&
          !this.displayAutoBalanceSubtab
          ? [
              {
                route: "overview",
                value: this.$t("contract_items"),
              },
              {
                route: "royalty_rates",
                value: this.$t("tab_title_royalty_rates"),
              },
              {
                route: "licencing",
                value: this.$t("licencing_nr"),
              },
              {
                route: "contract_deductions",
                value: this.$t("tab_title_contract_deductions"),
              },
              {
                route: "recoupables",
                value: this.$t("recoupables"),
              },
              {
                route: "balances",
                value: this.$t("balances"),
              },
              {
                route: "history",
                value: this.$t("history"),
              },
              {
                route: "specials",
                value: this.$t("specials"),
              },
            ]
          
        
          : this.displayContractDeductionsSubtab &&
            this.mechanicalFlag &&
            !this.displayAutoBalanceSubtab
          ? [
              {
                route: "overview",
                value: this.$t("contract_items"),
              },
              {
                route: "royalty_rates",
                value: this.$t("tab_title_royalty_rates"),
              },
              {
                route: "contract_deductions",
                value: this.$t("tab_title_contract_deductions"),
              },
              {
                route: "recoupables",
                value: this.$t("recoupables"),
              },
              {
                route: "history",
                value: this.$t("statement_history"),
              },
              {
                route: "specials",
                value: this.$t("specials"),
              },
            ]: this.mechanicalFlag && !this.displayContractDeductionsSubtab
          ? [
              {
                route: "overview",
                value: this.$t("contract_items"),
              },
              {
                route: "royalty_rates",
                value: this.$t("tab_title_royalty_rates"),
              },
              {
                route: "recoupables",
                value: this.$t("recoupables"),
              },
              {
                route: "history",
                value: this.$t("statement_history"),
              },
              {
                route: "specials",
                value: this.$t("specials"),
              },
            ]
          : this.displayAutoBalanceSubtab &&
            this.displayContractDeductionsSubtab
          ? [
              {
                route: "overview",
                value: this.$t("contract_items"),
                // vgi_id: "contract_setup"
              },
              {
                route: "royalty_rates",
                value: this.$t("tab_title_royalty_rates"),
                // vgi_id: "tab_title_royalty_rates"
              },
              {
                route: "licencing",
                value: this.$t("licencing_nr"),
              },
              {
                route: "contract_deductions",
                value: this.$t("tab_title_contract_deductions"),
              },
              {
                route: "recoupables",
                value: this.$t("recoupables"),
                // vgi_id: "recoupables"
              },
              {
                route: "balances",
                value: this.$t("balances"),
                // vgi_id: "tab_title_contract_balances"
              },

              {
                route: "history",
                value: this.$t("history"),
                // vgi_id: "tab_title_statement_history"
              },
              {
                route: "specials",
                value: this.$t("specials"),
                // vgi_id: "tab_title_specials"
              },
            ]
          : this.displayAutoBalanceSubtab &&
            !this.displayContractDeductionsSubtab
          ? [
              {
                route: "overview",
                value: this.$t("contract_items"),
                // vgi_id: "contract_setup"
              },
              {
                route: "royalty_rates",
                value: this.$t("tab_title_royalty_rates"),
                // vgi_id: "tab_title_royalty_rates"
              },
              {
                route: "licencing",
                value: this.$t("licencing_nr"),
              },

              {
                route: "recoupables",
                value: this.$t("recoupables"),
                // vgi_id: "recoupables"
              },
              {
                route: "balances",
                value: this.$t("balances"),
                // vgi_id: "tab_title_contract_balances"
              },

              {
                route: "history",
                value: this.$t("history"),
                // vgi_id: "tab_title_statement_history"
              },
              {
                route: "specials",
                value: this.$t("specials"),
                // vgi_id: "tab_title_specials"
              },
            ]
          : [
              {
                route: "overview",
                value: this.$t("contract_items"),
                // vgi_id: "contract_setup"
              },
              {
                route: "royalty_rates",
                value: this.$t("tab_title_royalty_rates"),
                // vgi_id: "tab_title_royalty_rates"
              },
              {
                route: "licencing",
                value: this.$t("licencing_nr"),
                // vgi_id: "tab_title_licencing_and_performance"
              },
              {
                route: "recoupables",
                value: this.$t("recoupables"),
                // vgi_id: "recoupables"
              },
              {
                route: "balances",
                value: this.$t("balances"),
                // vgi_id: "tab_title_contract_balances"
              },
              {
                route: "history",
                value: this.$t("history"),
                // vgi_id: "tab_title_statement_history"
              },
              {
                route: "specials",
                value: this.$t("specials"),
                // vgi_id: "tab_title_specials"
              },
            ]
      );
    },
    dBoxProductsRowCount: function () {
      return this.selectedContractDetails?.products?.length > 0
        ? this.selectedContractDetails?.products?.length
        : 0;
    },
    // TABULATION REFACTORING

    contract_id: function () {
      return this.$route.params.contract_id;
    },

    selectedContractDetails: function () {
      const selectedContract = this.contractsDetails?.[this.contract_id] || {};
      let contract = selectedContract.contract || {};
      //const notes = selectedContract?.specialContract?.notes || "";
      const template_flag =
        selectedContract?.contract?.template_flag == "1" ? true : false;
        const mechanical_flag =
        selectedContract?.contract?.mechanical_flag == 1 ? true : false;
        
      const template_name = selectedContract?.contract?.json_data
        ? JSON.parse(selectedContract.contract.json_data).template_name
        : "";
      contract = {
        ...contract,
        template_name,
        template_flag,
        mechanical_flag
      };
      const royalty_scales = selectedContract?.royalty_scales || [];
      const turnover_scale = selectedContract.turnover_scale;

      let scales;
      if (turnover_scale != null) {
        scales = [turnover_scale, ...royalty_scales];
      } else {
        scales = royalty_scales;
      }

      const label_statuses = selectedContract?.label_statuses || [];
      const labelStatusesTV = label_statuses.map((e) => {
        return {
          text: e["label_status_name"],
          color: e["label_status_colour"]
            ? `#${e["label_status_colour"]}`
            : "#000000",
          value: e["label_status_id"],
        };
      });

      // console.log({
      //   "contracts-sidewindow.vue:935 labelStatusesTV": labelStatusesTV,
      //   label_statuses,
      //   selectedContract,
      // });

      // createTV(
      //   label_statuses,
      //   "label_status_name",
      //   "label_status_id"
      // );

      const releases = selectedContract?.releases || [];

      const tracks = selectedContract?.tracks || [];

      const products = selectedContract?.products || [];

      const physical_royalty_options =
        selectedContract?.physical_royalty_options || [];

      const digital_royalty_options =
        selectedContract?.digital_royalty_options || [];

      const physical_ro_bases = selectedContract?.physical_ro_bases || [];
      const physicalBasesTV = physical_ro_bases.map((x) => {
        return {
          text: this.$t(x.textkey),
          value: this.$t(x.value),
        };
      });

      //createTV(physical_ro_bases, "textkey", "value");

      const digital_ro_bases = selectedContract?.digital_ro_bases || [];
      const digitalBasesTV = digital_ro_bases.map((x) => {
        return {
          text: this.$t(x.textkey),
          value: this.$t(x.value),
        };
      });

      //createTV(digital_ro_bases, "textkey", "value");

      const reserve_settings = selectedContract?.reserve_settings || [];

      const statements = selectedContract?.statements || [];

      const files = selectedContract?.files || [];

      const performance_royalty_options =
        selectedContract?.performance_royalty_options || [];

      const thirdparty_royalty_options =
        selectedContract?.thirdparty_royalty_options || [];

      const licensing_royalty_options =
        selectedContract?.licensing_royalty_options || [];

      // const balances = selectedContract?.balances || [];
      const obj = groupBy(selectedContract.balances, "period");
      let balances = [];
      if (Object.keys(obj).length > 0) {
        Object.keys(obj).forEach((value, index) => {
          let objectValues = Object.values(obj)[index];
          objectValues[0].new_group_title = 1;
          objectValues[0].group_title = this.$t(value);
          objectValues = objectValues.map((obj) => {
            obj.disabled = value === "open_balances" ? false : true;
            return obj;
          });
          balances.push(...objectValues);
        });
      }

      const balances_12 = selectedContract?.balances_12 || [];
      // console.log("balances_12 ", balances_12);
      const balances_34 = selectedContract?.balances_34 || [];
      // console.log("balances_34 ", balances_34);
      const balance_types_34 = selectedContract?.balance_types_34 || [];
      const balanceTypeTV = createTV(balance_types_34, "label", "value");
      // console.log("balanceTypeTV ", balanceTypeTV);

      const balance_types_12 = selectedContract?.balance_types_12 || [];
      const RecoupableBalanceTypeTV = createTV(
        balance_types_12,
        "label",
        "value"
      );
      // console.log("RecoupableBalanceTypeTV ", RecoupableBalanceTypeTV);

      const royalty_cost_groups = selectedContract?.royalty_cost_groups || [];

      const royalty_income_groups =
        selectedContract?.royalty_income_groups || [];

      const cost_split_types = selectedContract?.cost_split_types || [];
      const costSplitTypesTV = createTV(cost_split_types, "label", "value");

      const cost_groups = selectedContract?.cost_groups || [];
      const costGroupsTV = createTV(
        cost_groups,
        "cost_group_name",
        "cost_group_id"
      );

      const income_groups = selectedContract?.income_groups || [];
      const incomeGroupsTV = createTV(
        income_groups,
        "cost_group_name",
        "cost_group_id"
      );

      const relations = selectedContract?.relations || [];

      const mc = selectedContract.mc || {};

      const rates = selectedContract?.rates || [];
      const ratesTV = createTV(rates, "rate_name", "mechanical_rate_id");

      const territories = selectedContract?.territories || [];
      const territoriesTV = createTV(territories, "label", "value");

      return {
        ...selectedContract,
        contract,
        turnover_scale,
        scales,
        label_statuses,
        labelStatusesTV,
        releases,
        tracks,
        products,
        physical_royalty_options,
        physical_ro_bases,
        physicalBasesTV,
        digital_royalty_options,
        digital_ro_bases,
        digitalBasesTV,
        reserve_settings,
        statements,
        files,
        performance_royalty_options,
        thirdparty_royalty_options,
        licensing_royalty_options,
        balances,
        balances_12,
        balances_34,
        balance_types_34,
        balanceTypeTV,
        balance_types_12,
        RecoupableBalanceTypeTV,
        royalty_cost_groups,
        cost_groups,
        costGroupsTV,
        royalty_income_groups,
        cost_split_types,
        costSplitTypesTV,
        income_groups,
        incomeGroupsTV,
        relations,
        mc,
        rates,
        ratesTV,
        territories,
        territoriesTV,
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, contractsRoyaltyActions),
    async onApplyFilter(e) {
      const result = await ContractsService.searchContractRelatedItems({
        contract_id:
          this.selectedContractDetails?.contract?.contract_id,
        search:e.searchString,
        relation:e.action
      });
      if(e.action=='products'){
        this[ActionTypes.ContractProduct.SET.ALL]({
          selectedContractDetails:
          this.selectedContractDetails,
          products: result.data.products || [],
      });
      }
     else if(e.action=='tracks'){
        this[ActionTypes.ContractTrack.SET.ALL]({
          selectedContractDetails:
          this.selectedContractDetails,
          tracks: result.data.tracks || [],
      });
      }
     else if(e.action=='releases'){
        this[ActionTypes.ContractRelease.SET.ALL]({
          selectedContractDetails:
          this.selectedContractDetails,
          releases: result.data.releases || [],
      });
      }
      
    },
    onProductsSearchClick(flag) {
      console.log("flag", flag);
      this.productsSearchFlag = flag;
    },
    onTracksSearchClick(flag) {
      console.log("flag", flag);
      this.tracksSearchFlag = flag;
    },
    onReleasesSearchClick(flag) {
      console.log("flag", flag);
      this.releasesSearchFlag = flag;
    },
    onTabOptionClicked(value) {
      if (value == "documents") {
        openModalRoute2(this, "dtTemplateList", {
          external_id: this.contract_id,
        });
      } else if (value == "delete") {
        this.onDeleteContractClick();
      }
    },

    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },

    onContractChanged: function (payload) {
      this[ActionTypes.ContractsDetails.UPDATE.SINGLE]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
    },

    // Start Royalty Rates
    onRoyaltyRateChanged: function (channel, { name, value, item }) {
      this[ActionTypes.ContractRoyaltyRates.UPDATE.SINGLE]({
        channel,
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    addDeductions(e) {
      openModalRoute(this, "add_deductions_modal", {
        mode: "add",
        deductions_target: e,
      });
    },
    openEditProduct(item){
      openModalRoute(this, "edit_mechanical_product", {
        mode: "edit",
        ...item,
      });
    },
    editDeductions(item) {
      openModalRoute(this, "edit_deductions_modal", {
        mode: "edit",
        ...item,
      });
    },
    onRoyaltyRateAddClick: function (channel, e) {
      const seqLength =
        channel == "digital"
          ? this.selectedContractDetails?.digital_royalty_options.length
          : this.selectedContractDetails?.physical_royalty_options.length;

      console.log(":::seqLength", seqLength);

      openModalRoute(this, "royalty_rate_form", {
        mode: "add",
        channel,
        seqLength,
      });
    },

    onRoyaltyRateEditClick: function (channel, e) {
      openModalRoute(this, "royalty_rate_form", {
        mode: "edit",
        royalty_option_id: e.royalty_option_id,
        channel,
      });
    },
    async deleteContractDeduction(payload) {
      const confirmationResult = await confirmDelete("Deduction", payload.name);

      if (confirmationResult === "OK") {
        this[ActionTypes.ContractDeductions.DELETE.SINGLE]({
          ...payload,
          selectedContractDetails: this.selectedContractDetails,
        });

        this.onDialogCancelled();
      }
    },
    addedContractDedution: function (payload) {
      this[ActionTypes.ContractDeductions.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });

      this.onDialogCancelled();
    },
    onAddedRoyaltyRate: function (payload) {
      this[ActionTypes.ContractRoyaltyRates.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onEditedRoyaltyRate: function (payload) {
      this[ActionTypes.ContractRoyaltyRates.UPDATE.SINGLE]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onDeletedRoyaltyRate: function (channel, item) {
      this[ActionTypes.ContractRoyaltyRates.DELETE.SINGLE]({
        ...item,
        channel,
        contract_id: this.contract_id,
      });
    },

    onAddedReserveSetup: function (payload) {
      this[ActionTypes.ContractRoyaltyRatesReserve.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
    },

    onReserveSetupChanged: function ({ name, value, item }) {
      this[ActionTypes.ContractRoyaltyRatesReserve.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },

    onDeletedReserveSetup: function (item) {
      this[ActionTypes.ContractRoyaltyRatesReserve.DELETE.SINGLE]({
        ...item,
        contract_id: this.contract_id,
      });
    },

    // Start Licencing & NR
    onLicencingNrAddClick: function (channel, e) {
      openModalRoute(this, "licencing_nr_form", {
        mode: "add",
        channel,
      });
    },
    onLicencingNrEditClick: function (channel, e) {
      openModalRoute(this, "licencing_nr_form", {
        mode: "edit",
        royalty_option_id: e.royalty_option_id,
        channel,
      });
    },

    onEditedLicencingNr: function ({
      channel,
      name,
      value,
      item,
      saveRoyaltyOptionFlag,
      saveRoyaltyOption,
    }) {
      this[ActionTypes.ContractLicencingNr.UPDATE.SINGLE]({
        channel,
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
        saveRoyaltyOptionFlag,
        saveRoyaltyOption,
      });

      this.onDialogCancelled();
    },

    onAddedLicencingNr: function (payload) {
      this[ActionTypes.ContractLicencingNr.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onLicensingChanged: function (channel, { name, value, item }) {
      this[ActionTypes.ContractLicencingNr.UPDATE.SINGLE]({
        channel,
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },

    onDeletedLicensing: function (channel, item) {
      this[ActionTypes.ContractLicencingNr.DELETE.SINGLE]({
        ...item,
        channel,
        contract_id: this.contract_id,
      });
    },

    onScaleTypesClick: function () {
      if (this.selectedContractDetails.turnover_scale != null) {
        openModalRoute(this, "scale_quantity_form", {
          mode: "add",
        });
      } else {
        openModalRoute(this, "scale_types_form", {
          mode: "add",
        });
      }
    },

    onAddedScaleQtyClick: function (e) {
      openModalRoute(this, "scale_quantity_form", {
        mode: "add",
      });
    },

    onRoyaltyScaleQtyEditClick: function (e) {
      openModalRoute(this, "scale_quantity_form", {
        mode: "edit",
        royalty_scale_id: e.royalty_scale_id,
      });
    },

    onAddedScaleTurnoverClick: function (e) {
      openModalRoute(this, "scale_turnover_form", {
        mode: "add",
      });
    },

    onRoyaltyScaleTurnoverEditClick: function (e) {
      openModalRoute(this, "scale_turnover_form", {
        mode: "edit",
        royalty_scale_id: e.royalty_scale_id,
      });
    },

    onAddedQuantityScale: function (payload) {
      this[ActionTypes.ContractRoyaltyScale.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onEditedQuantityScale: function (payload) {
      this[ActionTypes.ContractRoyaltyScale.UPDATE.SINGLE]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onAddedTurnoverScale: function (payload) {
      this[ActionTypes.TurnoverScale.INSERT.SINGLE](payload);
      this.onDialogCancelled();
    },

    onEditedTurnoverScale: function (payload) {
      this[ActionTypes.TurnoverScale.UPDATE.SINGLE]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onRoyaltyScaleChanged: function ({ name, value, item }) {
      this[ActionTypes.ContractRoyaltyScale.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },

    onDeletedRoyaltyScale: function (item) {
      if (item.turnover_scale == 1) {
        this[ActionTypes.TurnoverScale.DELETE.SINGLE]({
          ...item,
          contract_id: this.contract_id,
        });
      } else {
        this[ActionTypes.ContractRoyaltyScale.DELETE.SINGLE]({
          ...item,
          contract_id: this.contract_id,
        });
      }
    },

    onHarryFoxChanged: function ({ name, value }) {
      this[ActionTypes.ContractMC.UPDATE.SINGLE]({
        name,
        value,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    // End Royalty Rates

    // Start Releases
    onContractItemsChanged: function ({ name, value, item }) {
      this[ActionTypes.ContractItems.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onContractReleasesChanged: function ({ name, value, item }) {
      this[ActionTypes.ContractRelease.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onContractProductsChanged: function ({ name, value, item }) {
      this[ActionTypes.ContractProduct.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onContractTracksChanged: function ({ name, value, item }) {
      this[ActionTypes.ContractTrack.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onContractDeletedAll: function (payload) {
      this[ActionTypes.ContractItems.DELETE.ALL]({
        ...payload,
        contract_id: this.contract_id,
      });
    },
    onContractDeleted: function (payload) {
      this[ActionTypes.ContractItems.DELETE.SINGLE]({
        ...payload,
        contract_id: this.contract_id,
      });
    },

    onSelectedRelease: function (selectedReleaseId) {
      this.$router.push({
        name: releasesListLDTRoutes.names.tab,
        params: {
          release_id: selectedReleaseId,
          tab: "overview",
        },
      });
    },

    onReleasesAddClick: function () {
      openModalRoute(this, "add_releases", {
        mode: "add",
      });
    },

    onTracksAddClick: function () {
      openModalRoute(this, "add_tracks", {
        mode: "add",
      });
    },

    onProductsAddClick: function () {
      openModalRoute(this, "add_products", {
        mode: "add",
      });
    },

    onReleasesAdded: function (payload) {
      this[ActionTypes.ContractRelease.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onTracksAdded: function (payload) {
      this[ActionTypes.ContractTrack.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onProductsAdded: function (payload) {
      this[ActionTypes.ContractProduct.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onAutoFillTrackList: function (payload) {
      this[ActionTypes.AutoFillTrack.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    onAutoFillFromReleases: function (payload) {
      this[ActionTypes.AutoFillRelease.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    // End Releases

    // Start Recoupables
    onRecoupablesChanged: function (channel, { name, value, item }) {
      this[ActionTypes.RoyaltyCostGroups.UPDATE.SINGLE]({
        channel,
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },

    onDeletedRecoupables: function (payload) {
      this[ActionTypes.RoyaltyCostGroups.DELETE.SINGLE]({
        ...payload,
        contract_id: this.contract_id,
      });
    },

    onAddedRecoupablesList: function (payload) {
      this[ActionTypes.RoyaltyCostGroups.INSERT.SINGLE]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
      this.onDialogCancelled();
    },

    // Based on Mechanical
    onAddedContractReserveSettings: function (payload) {
      // console.log("onAddedContractReserveSettings ", payload);
      this[ActionTypes.ContractlReserveSettings.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onContractReserveSettingsChanged: function ({ name, value, item }) {
      // console.log("onContractReserveSettingsChanged ", { name, value, item });
      this[ActionTypes.ContractlReserveSettings.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onDeletedContractReserveSettings: function (item) {
      // console.log("onAddedContractReserveSettings ", item);
      this[ActionTypes.ContractlReserveSettings.DELETE.SINGLE]({
        ...item,
        contract_id: this.contract_id,
      });
    },

    onContractBalancesChanged: function (channel, { name, value, item }) {
      // console.log("onContractBalancesChanged ", { channel, name, value, item });
      this[ActionTypes.RecoupableContractBalances.UPDATE.SINGLE]({
        channel,
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onfetchRecoupableBalance: function (payload) {
      this[ActionTypes.RecoupableContractBalances.SET.ALL]({
        channel: payload.channel,
        balances_34: [
          ...this.selectedContractDetails.balances_34,
          ...payload.balances_34,
        ],
        balances_12: [
          ...this.selectedContractDetails.balances_12,
          ...payload.balances_12,
        ],
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onAddedContractBalances: function (payload) {
      // console.log("onAddedContractReserveSettings ", payload);
      this[ActionTypes.RecoupableContractBalances.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onDeletedContractBalances: function (item) {
      console.log("onDeletedContractBalances ", item);
      this[ActionTypes.RecoupableContractBalances.DELETE.SINGLE]({
        ...item,
        contract_id: this.contract_id,
      });
    },

    // onDeletedLicensing: function(channel, item) {
    //   this[ActionTypes.ContractLicencingNr.DELETE.SINGLE]({
    //     ...item,
    //     channel,
    //     contract_id: this.contract_id
    //   });
    // },

    // End Recoupables

    onSelectedProducts: function (selectedProductId) {
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: selectedProductId,
          tab: "overview",
        },
      });
    },

    onAutoFetchAddClick: function () {
      openModalRoute(this, "auto_fetch_form", {
        mode: "add",
      });
    },

    onDeleteContractClick: async function (value) {
      console.log(
        "delete me tc ",
        value,
        this.selectedContractDetails.contract.contract_name
      );

      const confirmationResult = await confirmDelete(
        "contract",
        this.selectedContractDetails.contract.contract_name
      );

      if (confirmationResult === "OK") {
        this[ActionTypes.ContractTabDelete.DELETE.SINGLE]({
          contract_id: this.selectedContractDetails.contract.contract_id,
        });
        this.$store.dispatch(indexTypes.DELETE_SIDE_NAV_ITEM, {
          full_title: this.selectedContractDetails.contract.contract_id,
          route: this.selectedContractDetails.contract.contract_id,
          title: this.selectedContractDetails.contract.contract_id,
        });
        handleCloseTab(
          this.$store,
          {
            img: "static/icons/nav/royalty.svg",
            route: "royalty",
            store: "RoyaltyStore",
            title: "royalty",
            tkey: "royalty",
          },
          {
            primaryKey: "contract_id",
            route: "contracts",
            title: "Contracts",
            DetailsAction: ActionTypes.ContractsDetails,
          },
          {
            full_title: this.selectedContractDetails.contract.contract_id,
            route: this.selectedContractDetails.contract.contract_id,
            title: this.selectedContractDetails.contract.contract_id,
          }
        );
        handleFromRoute(this, () => {
          this.$router.push({
            name: royaltyContractsListLDTRoutes.names.list,
          });
        });
      }
    },

    // onDocumentsClick: function () {
    //   openModalRoute(this, "contract_document", {
    //     mode: "add",
    //   });
    // },

    onAddedAutoFetch: function (payload) {
      this[ActionTypes.ContractSpecials.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      }),
        this.onDialogCancelled();
    },

    onDeletedAutoFetch: function (payload) {
      this[ActionTypes.ContractSpecials.DELETE.SINGLE]({
        ...payload,
        contract_id: this.contract_id,
      });
    },

    // Start Notes
    onNotesBlur: function (event) {
      this.onContractChanged({
        name: "notes",
        value: event.target.value,
      });
    },
    // End Notes

    // Start Balance
    onBalanceChanged: function ({ name, value, item }) {
      this[ActionTypes.ContractBalance.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onfetchBalance: function (payload) {
      this[ActionTypes.ContractBalance.SET.ALL]({
        balances: [...this.selectedContractDetails.balances, ...payload],
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onContractBalance: function (payload) {
      this[ActionTypes.ContractBalance.SET.ALL]({
        ...payload,
        selectedContractDetails: this.selectedContractDetails,
      });
    },
    onDeletedBalance: function (payload) {
      this[ActionTypes.ContractBalance.DELETE.SINGLE]({
        ...payload,
        contract_id: this.contract_id,
      });
    },
    onAutoFetchLabelSupplierClick: async function () {
      // HTTP Request
      const res = await ContractsService.autoFetchLabelSupplier(
        this.contract_id
      );

      console.log("autoFetchLabelSupplier", res.data);

      // Refresh;
      this[ActionTypes.ContractsDetails.FETCH.SINGLE]({
        flag: true,
        contract: this.selectedContractDetails.contract,
        reload: true,
      });
    },
    // onRightMenuClick: function(menu) {
    //   if (menu == "auto_fetch_label_supplier") {
    //     this.$emit("auto_fetch_label_supplier", true);
    //   }
    // }
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 212px);
  }

  .tabs-options {
    .dt-button {
      &:last-child {
        margin-right: 0 !important;
      }
    }
  }
}
</style>
